import * as lou from '@/services/data/lou'
import NProgress from 'nprogress'

export async function getMasterCustom(url, showNotif = false, loadingRefresh = null) {
  try {
    if (loadingRefresh !== null) {
      loadingRefresh = true
      NProgress.start()
    }
    const res = await lou.customUrlGet2(url)
    if (!res) {
      lou.shownotif('Error!', `Failed to fetch data from ${url}`, 'error')
      return []
    }
    if (showNotif) {
      lou.shownotif('Refresh', 'Data telah di refresh.')
    }
    return res.data || []
  } catch (err) {
    lou.shownotif('Error!', `Unexpected error fetching ${url}`, 'error')
    console.log(err)

    return []
  } finally {
    if (loadingRefresh !== null) {
      setTimeout(() => {
        loadingRefresh = false
      }, 450)
      NProgress.done()
    }
  }
}

export function addLabelForSelect(data = [], code = 'nama_perusahaan', desc = 'nama_kontak', separator = ' - ') {
  return data.map(el => ({
    ...el,
    label: `${el[code]}${separator}${el[desc]}`,
  }))
}

export async function sendToAPI({ action, url, formData, onSuccess }) {
  try {
    let res = false
    const clonedData = JSON.parse(JSON.stringify(formData))
    if (action === 'update') {
      res = await lou.customUrlPut2(url, clonedData)
    } else {
      res = await lou.customUrlPost2(url, clonedData)
    }

    if (res) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess()
      }
    }

    return res
  } catch (error) {
    lou.shownotif('Error!', 'Failed to submit data', 'error')
    console.log(action, error)
    return false
  }
}
